export default __webpack_public_path__ + "f7b2622ee5a7573749553edaadb326c1.svg";